import { VKIcon } from '../../../../../assets/icons/socialNetwork/VK';
import { SocialNetworkButton } from './SocialNetworkButton';

import './style.scss';

interface VKButtonProps {
  children: string;
  url: string;
  onClick?(): void;
}

export const VKButton = ({ url, onClick, children }: VKButtonProps) => {
  return (
    <SocialNetworkButton
      icon={<VKIcon width={36} height={36} fill="#fff" outlined={false} />}
      url={url}
      onClick={onClick}
      className="vk-button"
    >
      <span className="vk-button__text">{children}</span>
    </SocialNetworkButton>
  );
};
